import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae42a0d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "explore-plants" }
const _hoisted_2 = { class: "explore-plants__search-container" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "explore-plants__title" }

import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { Skeleton } from 'ant-design-vue';

import { useStore } from '@/store';
import { getRecommendedPlants } from '@/api/plant';
import { ApiPlantResponseMasonry } from '@/@types/plant';
import { amplitudeInstance } from '@/analytics';

import PlantsGrid from '@/components/PlantsGrid.vue';
import SearchForm from '@/components/SearchForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExplorePlants',
  setup(__props) {

const { t } = useI18n();
const store = useStore();
const router = useRouter();

const isFetch = ref<boolean>(false);

const allPlants = computed<ApiPlantResponseMasonry[]>(
  () => store.state.plant.allPlants
);
const allPlantsPage = computed<number>(() => store.state.plant.allPlantsPage);

const getPlants = async () => {
  isFetch.value = true;

  const newPlants = await getRecommendedPlants({
    page: allPlantsPage.value,
  });

  const plantsList = [...allPlants.value, ...newPlants];
  const nextPage = allPlantsPage.value + 1;

  store.dispatch('plant/setAllPlants', plantsList);
  store.dispatch('plant/setAllPlantsPage', nextPage);

  isFetch.value = false;
};

const handleScroll = () => {
  if (isFetch.value) return;

  const { clientHeight, scrollHeight, scrollTop } = document.documentElement;

  const bottomOffset = 200;
  const isFetchPermit = scrollHeight - clientHeight - scrollTop <= bottomOffset;

  if (isFetchPermit) {
    getPlants();
  }
};

const searchPlants = (searchStr: string) => {
  store.dispatch('plant/setSearchPlantsResult', []);

  router.push({
    name: 'SearchResults',
    query: { plant: searchStr },
  });
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);

  if (allPlants.value.length === 0) {
    getPlants();
  }

  amplitudeInstance.logEvent('Explore-plants_shown');
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SearchForm, {
        class: "explore-plants__search",
        onSearch: searchPlants
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)('page_explore_title')), 1),
      _createVNode(PlantsGrid, {
        plants: _unref(allPlants),
        masonry: "",
        "amplitude-key": "explore-plants"
      }, null, 8, ["plants"]),
      (isFetch.value)
        ? (_openBlock(), _createBlock(_unref(Skeleton), {
            key: 0,
            active: ""
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})